import { render, staticRenderFns } from "./ServicePlaceEdit.vue?vue&type=template&id=4afe497c&scoped=true&"
import script from "./ServicePlaceEdit.vue?vue&type=script&lang=js&"
export * from "./ServicePlaceEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4afe497c",
  null
  
)

export default component.exports